module.exports = __webpack_public_path__ + "img/logo.1b8fe2b4.svg";